import React, { FC } from 'react';
import { SlotComponentProps } from '../../types';
import { BuildPCPicker } from 'components/desktop/organisms';

export type BuildPCPickerDesktopSlotProps = SlotComponentProps<{}>;

export const BuildPCPickerDesktopSlot: FC<
  BuildPCPickerDesktopSlotProps
> = () => {
  return <BuildPCPicker />;
};
